import * as yup from 'yup';
import { generateYupSchema } from 'utils/SchemaGenerator';
import { RuleParameterSchemaItem, RuleParameterValues } from '../types';

export function getRuleParameterValidationError(
  schema: RuleParameterSchemaItem[],
  values: RuleParameterValues
) {
  const validationShape = schema.reduce<Record<string, yup.AnySchema>>(
    (shape, field) => generateYupSchema(shape, field as never),
    {}
  );

  try {
    yup.object().shape(validationShape).validateSync(values);
    return '';
  } catch (error) {
    return error instanceof yup.ValidationError
      ? error.message
      : 'One or more rule parameters are invalid.';
  }
}
